import * as React from 'react';
import * as switchStyles from './switchCssDefs';
import { Switch as MuiSwitch } from '@mui/material';
import { SwitchProps as MuiSwitchProps } from '@mui/material/Switch';
import { css } from '@emotion/react';

export interface SwitchProps extends Pick<MuiSwitchProps, Exclude<keyof MuiSwitchProps, 'size'>> {
  size?: 'large' | 'medium' | 'small';
}

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Switch: React.FunctionComponent<React.PropsWithChildren<SwitchProps>> = ({
  className,
  checked,
  value,
  onChange,
  size,
  inputProps,
  name,
  id,
  ...rest
}) => {
  const rootStyle =
    size === 'small'
      ? switchStyles.rootSmall
      : size === 'large'
        ? switchStyles.rootLarge
        : switchStyles.root;
  const thumbStyle =
    size === 'small'
      ? switchStyles.thumbSmall
      : size === 'large'
        ? switchStyles.thumbLarge
        : switchStyles.thumb;
  const trackStyle =
    size === 'small'
      ? switchStyles.trackSmall
      : size === 'large'
        ? switchStyles.trackLarge
        : switchStyles.track;

  return (
    <MuiSwitch
      {...rest}
      css={(theme) => css`
        ${rootStyle(theme)}

        & .MuiSwitch-switchBase {
          ${switchStyles.switchBase(theme)}
        }

        & .MuiSwitch-thumb {
          ${thumbStyle(theme)}
        }

        & .MuiSwitch-track {
          ${trackStyle(theme)}
        }
      `}
      className={className}
      color="primary"
      id={id}
      inputProps={{
        ...inputProps,
      }}
      checked={checked}
      onChange={onChange}
      value={value}
      role="switch"
      aria-checked={checked}
    />
  );
};

export default Switch;
